'use client'

import Box from '@mui/material/Box'
import Text from '@mui/material/Typography'
import { FC } from 'react'

import TwoColumnsWithBackgroundImage from '@/components/TwoColumnsWithBackgroundImage'
import useDevice from '@/hooks/useDevice'

const Over50kCompaniesFintech: FC = () => {
    const { mdScreen } = useDevice()

    return (
        <TwoColumnsWithBackgroundImage
            sx={{
                ...(mdScreen ? {} : { height: '440px' }),
            }}
            backgroundImage={'/images/fintech-and-banking/reporting-green-desktop.png'}
            mobileBackgroundImage={'/images/fintech-and-banking/reporting-green-mobile.png'}
            leftSide={
                <Box
                    sx={{
                        gap: mdScreen ? 3 : 4,
                        display: 'flex',
                        alignItems: 'flex-start',
                        justifyContent: 'space-between',
                        flexDirection: 'column',
                    }}
                >
                    <Text variant={mdScreen ? 'h5' : 'h4'} sx={{ maxWidth: '435px' }}>
                        Over 50,000 companies will have to report their value chain emissions, with
                        the first reports due in 2025.
                    </Text>
                </Box>
            }
            reversedOnMobile={false}
        />
    )
}

export default Over50kCompaniesFintech
